
export function isAuthenticated() {
  return sessionStorage.getItem('isLoggedIn') === 'true';
}

export function setLoggedIn(val = true) {
  sessionStorage.setItem('isLoggedIn', val ? 'true' : 'false');
}

export function removeLoggedIn() {
  sessionStorage.removeItem('isLoggedIn');
}

export function getUserFromToken() {
  // Not storing user data in storage; fetch user via API elsewhere
  return null;
}

// Admin authentication utilities
export function isAdminAuthenticated() {
  const adminMode = sessionStorage.getItem('admin_mode');
  return isAuthenticated() && adminMode === 'admin';
}

export function setAdminMode(mode = 'admin') {
  sessionStorage.setItem('admin_mode', mode);
}

export function getAdminMode() {
  return sessionStorage.getItem('admin_mode');
}

export function removeAdminMode() {
  sessionStorage.removeItem('admin_mode');
  sessionStorage.removeItem('admin_user');
}

export function getAdminUser() {
  const adminUserStr = sessionStorage.getItem('admin_user');
  if (!adminUserStr) return null;
  try {
    return JSON.parse(adminUserStr);
  } catch {
    return null;
  }
}

export function setAdminUser(user) {
  sessionStorage.setItem('admin_user', JSON.stringify(user || {}));
}

/**
 * Clear all authentication-related sessionStorage keys
 * This ensures a clean logout state for both admin and regular users
 */
export function clearAllAuth() {
  // Clear login flag
  removeLoggedIn();
  
  // Clear admin-related keys
  removeAdminMode();
  
  // Clear service selection
  sessionStorage.removeItem('selectedServiceSlug');
  
  // Clear redirect flag
  sessionStorage.removeItem('_redirecting');
}

export function clearAdminAuth() {
  clearAllAuth();
}
